import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const Invite = ({
  eyebrow = "Ready to talk",
  title = "Bring us a problem worth engineering through.",
  text = "Tell us what you are trying to change. We respond within one business day with a clear next step — even if our honest read is that it isn't us."
}) => (
  <section className="invite">
    <div className="shell">
      <div className="layout">
        <div>
          <span className="eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="actions">
          <Link to="/contact" className="btn btn--mint">
            Start engagement <FiArrowRight />
          </Link>
          <Link to="/services" className="btn btn--line">All services</Link>
        </div>
      </div>
    </div>
  </section>
);

export default Invite;
